import type { Utilities } from 'core/domains';

import { bodyResolver } from './body-resolver';

export function getParams({
  headers,
  method = 'GET',
  mode = 'cors',
  payload,
  type,
  url,
  ...props
}: {
  method?: string;
  mode?: 'cors' | 'no-cors' | 'same-origin';
  payload: Record<string, unknown>;
  type: 'JSON' | 'urlencoded';
  url?: string;
  headers: Utilities.PlainObject;
}) {
  const params: RequestInit = {
    body: undefined,
    headers,
    method,
    mode,
    credentials: undefined,
  };

  if (!url) {
    params.credentials = 'include';
  }

  if (params.method !== 'GET') {
    params.body = bodyResolver({ payload, type });
  }

  return {
    headers,
    method,
    mode,
    payload,
    type,
    url,
    params,
    ...props,
  };
}
